import type { ReactNode } from 'react';

/**
 * The heading above a row or grid of content.
 *
 * Renders a real `<h2>` rather than a styled div, so the page has a genuine
 * outline for anyone navigating by heading.
 */
export function SectionHeader({
  title,
  description,
  action,
}: {
  readonly title: string;
  readonly description?: string;
  readonly action?: ReactNode;
}) {
  return (
    <div className="mb-4 flex items-end justify-between gap-4">
      <div className="min-w-0">
        <h2 className="text-[0.9375rem] font-semibold tracking-tight text-text-1">{title}</h2>
        {description !== undefined && (
          <p className="mt-0.5 text-[0.8125rem] text-text-3">{description}</p>
        )}
      </div>
      {action !== undefined && <div className="shrink-0">{action}</div>}
    </div>
  );
}
